import _en from './en';
import _vn from './vn';
let enData ={}
Object.keys(_en).forEach(k=>{
    enData[k] = _en[k]||k
})
export const EN = enData;
export const VN = _vn;
